
import Menu from './Compartido/Menu.jsx';
import Buscador from './Buscar2/Buscador.jsx';
import PropiedadesBuscar from './Buscar2/PropiedadesBuscar.jsx';
import Footer from './Compartido/Footer.jsx';

const Inicio = (props) => {

    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <Buscador
                destino={props.urldestino}
                destinos={props.destinos}
                tiposcasas={props.tipocasasdestino}
                adultos={props.adultos}
                ninos={props.ninos}
                bebes={props.bebes}
                llegada={props.llegada}
                salida={props.salida}
                tipocasa={props.tipocasa}
                lang={props.lang}
                config={props.websgrupo}
                capacidad_maxima={props.capacidad_maxima}
                barrios={props.barriosdestino}
                barrio={props.barrio}
            />
            <PropiedadesBuscar
                lang={props.lang}
                ruta={props.ruta}
                propiedades={props.propiedades}
                elementosweb={props.elementosweb}
                adultos={props.adultos}
                ninos={props.ninos}
                bebes={props.bebes}
                llegada={props.llegada}
                salida={props.salida}
                config={props.websgrupo}
                moneda={props.moneda}
            />
            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    );
}

export default Inicio;
